document.addEventListener("DOMContentLoaded", (event) => {

    const colorPath = document.querySelector('#drawPath');
    const pPath = document.querySelector('#drawPathP');

    // ヒーローSVGが無いページでは何もしない
    if (!colorPath || !pPath) {
        return;
    }

    const colorLength = colorPath.getTotalLength();
    const pLength = pPath.getTotalLength();

    gsap.set(colorPath, {
        strokeDasharray: colorLength,
        strokeDashoffset: colorLength
    });
    gsap.set(pPath, {
        strokeDasharray: pLength,
        strokeDashoffset: pLength
    });

    // 【追加】最初はカラー表示にする(CSSの白黒指定を上書き)
    gsap.set("#hero-bg", { filter: "grayscale(0%)" });

    // #hero-p を描画タイミングまで非表示
    gsap.set("#hero-p", { visibility: "hidden" });

    // 文字を上に待機させておく（これがないとバウンドしない）
    gsap.set(".hero-subtitle p span", {
        display: "inline-block",
        y: -120,
        opacity: 0
    });

    const tl = gsap.timeline();

    tl.set("#hero-p", { visibility: "visible" })

        // P表示
        .to(pPath, {
            strokeDashoffset: 0,
            duration: 1.5,
            ease: "none"
        })

        // カラーで表示
        .to(colorPath, {
            strokeDashoffset: 0,
            duration: 1.5,
            ease: "power2.inOut"
        })

        // 【追加】カラー表示のあと、白黒に変化
        .to("#hero-bg", {
            filter: "grayscale(100%)",
            duration: 1,
            ease: "power2.inOut"
        }, "+=0.3")

        // p自体は即表示し、文字をバウンドで落とす
        .set(".hero-subtitle p", { opacity: 1, x: 0 })
        .to(".hero-subtitle p span", {
            y: 0,
            opacity: 1,
            duration: 1.2,
            ease: "bounce.out",
            stagger: 0.06
        })

        // 少し停止
        .to({}, {
            duration: 0.5
        })

        .to(".hero-logo", {
            opacity: 1,
            scale: 1.15,
            duration: 0.8,
            ease: "power2.out"
        })

        // 「いろんな」の::before装飾のみ表示（追加したspanは対象外）
        .to(".hero-subtitle p span:not(.js-char--plain)", {
            "--before-opacity": 1,
            "--before-scale": 1.15,
            duration: 1,
            ease: "power2.out",
        })

        .to(".home #wrapper-navbar", {
            y: 0,
            opacity: 1,
            duration: 0.8,
            ease: "power2.out"
        });


    function animateHue() {
        gsap.to("#hero-p", {
            opacity: .6,
            filter: `hue-rotate(${gsap.utils.random(0, 360)}deg)`,
            duration: gsap.utils.random(3, 8),
            ease: "sine.inOut",
            onComplete: animateHue
        });
    }

    animateHue();
});

 

document.addEventListener('DOMContentLoaded', () => {

    /** ===============================
     *  スクロール登場アニメーション（4方向対応）
     *  =============================== */
    const targets = document.querySelectorAll('.fade-up, .fade-down, .fade-left, .fade-right');
    if (!targets.length) return; // 対象が無いページでは何もしない

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                observer.unobserve(entry.target); // 一度表示したら監視終了
            }
        });
    }, {
        threshold: 0.2,                      // 要素の20%が見えたら発火
        rootMargin: '0px 0px -50px 0px'      // 画面下端より50px手前を発火ラインに
    });

    targets.forEach((target) => {
        // --- delayの算出 ---
        // HTML側で style="--delay: 0.3s" と直接指定されていればそれを優先。
        // 無ければ「同じ親要素内での順番」から自動で時差を付ける。
        if (!target.style.getPropertyValue('--delay')) {
            const siblings = target.parentElement.querySelectorAll(
                '.fade-up, .fade-down, .fade-left, .fade-right'
            );
            const index = Array.prototype.indexOf.call(siblings, target);
            target.style.setProperty('--delay', `${index * 0.15}s`);
        }

        observer.observe(target);
    });
});

jQuery(function ($) {
  $('.js-sync-gallery').each(function (index) {
    var $gallery = $(this);

    var $main  = $('<div class="sync-slider-main" />');
    var $thumb = $('<div class="sync-slider-thumb" />');

    $gallery.find('.wp-block-image').each(function () {
      var $img     = $(this).find('img').clone().removeAttr('srcset sizes');
      var $caption = $(this).find('figcaption');

      // --- メイン側：画像＋キャプション ---
      var $mainSlide = $('<div class="sync-slide" />').append($img.clone());
      if ($caption.length) {
        $mainSlide.append(
          $('<div class="sync-slide-caption" />').html($caption.html())
        );
      }
      $main.append($mainSlide);

      // --- サムネイル側：画像のみ ---
      $thumb.append($('<div class="sync-slide" />').append($img.clone()));
    });

    var $wrap = $('<div class="sync-slider-wrap" />').append($main).append($thumb);
    $gallery.replaceWith($wrap);

    $main.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      adaptiveHeight: true, // キャプションの行数差で高さが変わる場合に追従
      asNavFor: $thumb
    });

    $thumb.slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: $main,
      focusOnSelect: true,
      arrows: true,
      responsive: [
        { breakpoint: 768, settings: { slidesToShow: 4 } }
      ]
    });
  });

    // アコーディオンが開いたらスライダーを再計算
  $(document).on('shown.bs.collapse', '.accordion-collapse', function () {
    $(this).find('.sync-slider-main, .sync-slider-thumb').each(function () {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('setPosition');
      }
    });
  });
});



//要素が20%見えたタイミングでクラスを付与

document.addEventListener('DOMContentLoaded', () => {

    const targets = document.querySelectorAll('.js-inview');
    if (!targets.length) return; // 対象が無いページでは何もしない

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-inview');
                observer.unobserve(entry.target); // 一度表示したら監視解除（再アニメ不要な場合）
            }
        });
    }, {
        threshold: 0.2 // 要素の20%が見えたら発火
    });

    targets.forEach(target => observer.observe(target));
});



